import { authentication } from "./authentication";
import { announcements } from "./announcements";
import { photos } from "./photos";
import { users } from "./users";
import { drafts } from "./drafts";
import { invoice } from "./invoice";
import { contactRequest } from "./contact-requests";
import { permissions } from "./permissions";
import { advice } from "./advice";
import { blog } from "./blog";
import { stat } from "./stat";

export const api = {
  authentication,
  announcements,
  photos,
  users,
  drafts,
  invoice,
  contactRequest,
  permissions,
  advice,
  blog,
  stat,
};
